import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getToken, isTokenExpired } from "./utils/auth";

const ProtectedRoutes = () => {
  const location = useLocation();
  const token = getToken();

  if (!token || isTokenExpired(token)) {
    localStorage.setItem("redirectAfterLogin", location.pathname);
    return <Navigate to="/SignIn" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
